<div class="relative flex flex-col min-w-0 break-words w-full">

    <list-utils-bar (valueChanged)="onSearchTermChange($event)" [isSearching]="isSearching$"
        [showingResults]="showingSearchResults$" (onSearch)="onSearch($event)" (onCancel)="onCancelSearch()"
        (onRefresh)="onRefresh()"></list-utils-bar>

    @let loading = (loading$ | async);
    @let isSearching = (isSearching$ | async);
    @let showingSearchResults = (showingSearchResults$ | async);

    @for (item of members$ | async; track item.id) {
    <div #itemRef [attr.data-id]="item.id" class="bg-white shadow-lg rounded w-full p-4 mb-4 flex flex-col gap-2"
        [class.bg-yellow-400]="item.id === firstNewItemId">
        <div class="flex items-start justify-between flex-row w-full">
            <div [routerLink]="['../faculty', item.memberId]" class="cursor-pointer">
                <div class="flex items-center">
                    <div class="inline-block flex-none">
                        @if(item.photoURL) {
                        <img [src]="item.photoURL"
                            class="min-h-10 max-h-10 max-w-10 min-w-10 bg-gray-100 object-cover rounded-full border-none" />
                        } @else {
                        <div
                            class="bg-primary-100 uppercase text-primary-500 text-base flex justify-center items-center text-center min-h-10 max-h-10 max-w-10 min-w-10 rounded-full">
                            {{ item.name | initials }}
                        </div>
                        }
                    </div>
                    <div class="flex-1 flex-col inline-flex flex-span ml-3">
                        <span class="text-sm text-primary-500 font-bold whitespace-nowrap">{{item.name |
                            titlecase}}</span>
                        <span class="text-xs text-primary-300 font-light whitespace-nowrap">
                            Joined: {{ item.created | moment: 'Do MMM YYYY' }}
                        </span>
                    </div>
                </div>
            </div>
            <div class="flex flex-row gap-2 whitespace-nowrap">
                <app-btn-fab (click)="onViewProfile(item)" tooltip="View Profile" icon="fas fa-eye"></app-btn-fab>
                <app-btn-fab (click)="onAssignRole(item)" tooltip="Change Role"
                    icon="fas fa-id-card-clip"></app-btn-fab>
                <app-change-member-status [item]="item"></app-change-member-status>
            </div>
        </div>
        <div class="flex flex-row gap-1 whitespace-nowrap">
            @if (item.memberType?.includes(memberType.president)) {
            <app-btn-chip [label]="memberType.president" color="text-primary-500"
                bgColor="bg-secondary-100"></app-btn-chip>
            }
            @if (item.memberType?.includes(memberType.principal)) {
            <app-btn-chip [label]="memberType.principal" color="text-primary-500"
                bgColor="bg-secondary-100"></app-btn-chip>
            }
            @if (item.memberType?.includes(memberType.teacher)) {
            <app-btn-chip [label]="memberType.teacher"></app-btn-chip>
            }
            @if (item.memberType?.includes(memberType.parent)) {
            <app-btn-chip [label]="memberType.parent"></app-btn-chip>
            }
        </div>
    </div>
    } @empty {
    @if(!(loading || isSearching)) {
    <div class="px-6 py-4 text-center font-semibold border-0 whitespace-nowrap">
        No Faculty Found
    </div>
    } @else {
    <loading-member></loading-member>
    }
    }
</div>
@if(!(isSearching || showingSearchResults)) {
<div class="flex flex-row w-full justify-center">
    <app-btn-more (click)="addMore()" [isDisabled]="loading || (isSearching ?? false)"></app-btn-more>
</div>
}